import { useFeatureIsOn } from "@growthbook/growthbook-react";

export const TRACKERS_FEATURE_FLAG = "recording-trackers";
export const INTERNAL_TRACKERS_FEATURE_FLAG = "internal-recording-trackers";
export const CONCEPT_TRACKERS_FEATURE_FLAG = "concept-trackers";

export function useTrackersFeatureFlagOn(): boolean {
	return useFeatureIsOn(TRACKERS_FEATURE_FLAG);
}

export function useConceptTrackersFeatureFlagOn(): boolean {
	return useFeatureIsOn(CONCEPT_TRACKERS_FEATURE_FLAG);
}
